module.exports = __webpack_public_path__ + "media/images/samples/300x300/9-3418392ecc11626fd58b3248b840a66a.jpg";